import { CheckboxProps } from '@slal/ui/forms';
import { StyledCheckbox } from './styles';

export const Checkbox = ({ ...props }: CheckboxProps) => {
    return <StyledCheckbox {...props} />;
};
